/**
 * This file gets geolocation
 */
import makeHttpRequest from '~/helpers/ajax';
import wwwUrlEnv from '~/helpers/www-url-env';

const errorData = {
    city: 'Charlotte', state: 'NC', zipCode: '28277', err: false, errorMessage: 'Something went wrong.',
};
const errorDataNonUS = {
    city: 'Charlotte', state: 'NC', zipCode: '28277', err: false, errorMessage: 'Not in US',
};

const GetGeoLocationURL = (locationType, value) => wwwUrlEnv.getWWWURL() + locationType + value;

/*
 * {
 *   "inputIndex": 0,
 *   "inputId": "28277",
 *   "cityStates": [
 *     {
 *       "cityName": "Charlotte",
 *       "isMailable": true,
 *       "stateCode": "NC",
 *       "stateName": "North Carolina"
 *     }
 *   ],
 *   "zipCodes": [
 *     {
 *       "zip5": "28277",
 *       "zipCodeType": "Standard",
 *       "defaultCity": "Charlotte",
 *       "countyFips": "37119",
 *       "countyName": "Mecklenburg",
 *       "stateCode": "NC",
 *       "stateName": "North Carolina",
 *       "latitude": 35.05401,
 *       "longitude": -80.81966,
 *       "precision": "Zip5",
 *       "alternateCounties": []
 *     }
 *   ]
 * }
 */
const GetZipCode = (zipValue) => {
    const locationType = '/geo/zip/v2?postalcode=';
    const url = GetGeoLocationURL(locationType, zipValue);
    return makeHttpRequest({ url }).then((response) => {
        try {
            const location = JSON.parse(response);
            if (location.zipCodes?.length > 0) {
                const zipData = location.zipCodes[0];
                return Promise.resolve({
                    city: zipData.defaultCity,
                    state: zipData.stateCode || zipData.stateName,
                    zipCode: zipData.zip5,
                });
            }
        } catch {
            return Promise.resolve({
                city: '', state: '', zipCode: '', err: true,
            });
        }
    }, () => Promise.resolve({
        city: '', state: '', zipCode: '', err: true,
    }));
};

const GetIpAddress = (zipValue) => {
    const locationType = '/geo/ip?ipAddress=';
    let zipCode = zipValue;

    if (!zipValue) {
        zipCode = '';
    }
    const url = GetGeoLocationURL(locationType, zipCode);
    return makeHttpRequest({ url }).then((response) => {
        const location = JSON.parse(response);
        if (!location.PostalCode
            || !location.City
            || (!location.Region && !location.StateProvinceCode)
            || location.CountryCode?.toUpperCase() !== 'US'
            || location.CountryRegionCode?.toUpperCase() !== 'US') {
            return Promise.reject(errorDataNonUS);
        }
        return Promise.resolve({
            city: location.City,
            state: location.Region || location.StateProvinceCode,
            zipCode: location.PostalCode,
            ipAddress: location.ipAddress,
            countryCode: location.CountryCode,
        });
    }, () => Promise.reject(errorData));
};

export {
    GetZipCode,
    GetIpAddress,
};
